import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: 'Who is the Creator Lab for?',
    answer: 'YouTube-first creators who already involve their audience in decisions — whether through polls, comments, or community posts — and want a better tool for it. You should be comfortable experimenting with new formats and genuinely curious about what your audience thinks.'
  }, {
    question: 'How much time does it take?',
    answer: "About 2–3 hours per week. You'll set up one Pulse Market per week, share it with your audience, and join a short weekly call with the cohort. The rest happens naturally as part of your content workflow."
  }, {
    question: 'Do I need to post a certain amount?',
    answer: 'We ask each creator to run at least one Pulse Market per week during the 4-week program. Beyond that, there are no posting requirements — we want quality engagement, not busywork.'
  }, {
    question: 'How big is each cohort?',
    answer: 'Five creators per cohort. Small enough for real conversation and feedback, large enough to learn from different approaches and audiences.'
  }, {
    question: 'What platforms does it work with?',
    answer: 'Pulsewave is platform-agnostic. You get a shareable link that works anywhere — YouTube community posts, video descriptions, Instagram stories, X, Discord, wherever your audience is.'
  }, {
    question: 'What are points? Is this gambling?',
    answer: "No. Points are a reputation system, not real money. Fans earn points by making accurate predictions, which gives them status in your community. There is no financial risk for anyone — it's about engagement and bragging rights."
  }, {
    question: 'What happens if a market flops?',
    answer: "That's useful data, not a failure. Some markets will get more engagement than others, and that teaches you what your audience actually cares about. The cohort calls are designed to help you iterate and improve."
  }, {
    question: 'How is this different from a poll?',
    answer: 'Polls are one-tap, low-commitment, and usually forgotten. A Pulse Market is tied to a real creator goal, fans stake their reputation on an outcome, and the whole thing plays out over time — creating a content arc from setup to resolution.'
  }];
  return <section id="faq" className="py-28 lg:py-40 bg-navy-950 border-t border-slate-800/30" data-id="element-68">
      <div className="max-w-3xl mx-auto px-6" data-id="element-69">
        <div className="mb-14" data-id="element-70">
          <h2 className="text-4xl lg:text-5xl font-extrabold text-white" data-id="element-71">
            FAQ
          </h2>
        </div>

        <div className="space-y-3" data-id="element-72">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className={`rounded-xl border transition-colors duration-300 ${isOpen ? 'bg-slate-900/50 border-slate-700/50' : 'bg-slate-900/30 border-slate-800/40 hover:border-slate-700/40'}`} data-id="element-73">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left group" aria-expanded={isOpen} data-id="element-74">
                  <span className="text-lg font-semibold text-slate-200 group-hover:text-white transition-colors pr-4" data-id="element-75">
                    {faq.question}
                  </span>
                  <ChevronDown className={`w-5 h-5 flex-shrink-0 transition-all duration-300 ${isOpen ? 'rotate-180 text-mint-400' : 'text-slate-600'}`} data-id="element-76" />
                </button>

                <AnimatePresence data-id="element-77">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25
              }} data-id="element-78">
                      <div className="px-6 pb-6 pt-1" data-id="element-79">
                        <p className="text-slate-400 leading-relaxed" data-id="element-80">
                          {faq.answer}
                        </p>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}